import { createApi } from "@reduxjs/toolkit/query/react";
import { encryptedBaseQueryWithReauth } from "../utilities/encryptedBaseQuery";

export const permissionsApi = createApi({
    reducerPath: "permissionsApi",
    baseQuery: encryptedBaseQueryWithReauth(process.env.REACT_APP_LOCAL_URL),
    // baseQuery: encryptedBaseQueryWithReauth(process.env.REACT_APP_LOCAL_URL),
    tagTypes: ["getPermissions", "getPermissionsById", "createPermission", "updatePermission"],
    endpoints: (builder) => ({
        getPermissions: builder.query({
            query: (endpoint) => `${endpoint}`,
            providesTags: ["getPermissions"],
            method: "GET"
        }),
        
        getPermissionsById: builder.query({
            query: (endpoint) => `${endpoint}`,
            providesTags: ["getPermissionsById"],
        }),

        createPermission: builder.mutation({
            query: ({ endpoint, data }) => {
                return {
                    url: endpoint,
                    method: "POST",
                    body: data,
                };
            },
            invalidatesTags: ["createPermission"],
        }),

        updatePermission: builder.mutation({
            query: ({ endpoint, updatedData }) => {
                return {
                    url: endpoint,
                    method: "PATCH",
                    body: updatedData,
                };
            },
            invalidatesTags: ["updatePermission"],
        }),
         updatePermissionStatus: builder.mutation({
            query: ({ endpoint, updatedData }) => {
                return {
                    url: endpoint,
                    method: "PATCH",
                    body: updatedData,
                };
            },
            invalidatesTags: ["updatePermissionStatus"],
        }),
        deletePermission: builder.mutation({
            query: ({ endpoint }) => {
                return {
                    url: endpoint,
                    method: "DELETE",
                   
                };
            },
            invalidatesTags: ["deletePermission"],
        }),
    }),
});

export const {
    useCreatePermissionMutation,
    useGetPermissionsQuery,
    useGetPermissionsByIdQuery,
    useUpdatePermissionMutation,
    useUpdatePermissionStatusMutation,
    useDeletePermissionMutation
} = permissionsApi;
